// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page{padding:115px 0 100px}.error-page__title{margin-bottom:16px;font-weight:400;font-size:40px;line-height:48px}@media (max-width:767px){.error-page__title{text-align:center}}.error-page__info{margin:0}@media (max-width:767px){.error-page__info{margin-bottom:16px;text-align:center}}@media (max-width:767px){.error-page__image{display:block;margin:0 auto}}", ""]);
// Exports
module.exports = exports;
